import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, useState } from 'react';

import AddAmazonLiveModal from '../AddAmazonLiveModal';
import ConnectToFacebookModal from '../ConnectToFacebookModal';
import CustomRTMPModal from '../CustomRTMPModal';
import FacebookGroupWarning from '../FacebookGroupWarning';
import { getDestinationList } from '../helpers';

type HookProps = {
  waveApiUrl: string;
  isReconnect: boolean;
  showModals?: boolean;
};

const useAddDestination = ({ showModals = true, isReconnect, ...otherProps }: HookProps) => {
  const [destinationTitle, setDestinationTitle] = useState('');
  const [isRTMPModalOpened, openRTMPModal, closeRTMPModal] = useSwitchState();
  const [connectFBModalOpened, openConnectFBModal, closeConnectFBModal] = useSwitchState();
  const [facebookGroupModalOpen, openFacebookGoupModal, closeFacebookGoupModal] = useSwitchState();
  const [isAmazonLiveModalOpened, openAmazonLiveModal, closeAmazonLiveModal] = useSwitchState();

  const handleFacebookClick = useCallback((title = '') => {
    setDestinationTitle(title);
    openConnectFBModal();
  }, []);

  const addDestinationList = getDestinationList({
    ...otherProps,
    isReconnect,
    onRTMPClick: openRTMPModal,
    onAmazonLiveClick: openAmazonLiveModal,
    onFacebookClick: handleFacebookClick,
    onFacebookGroupClick: openFacebookGoupModal
  });

  const renderRTMPModal = () => isRTMPModalOpened && showModals && <CustomRTMPModal onModalClose={closeRTMPModal} />;

  const renderAmazonLiveModal = () =>
    isAmazonLiveModalOpened && showModals && <AddAmazonLiveModal onModalClose={closeAmazonLiveModal} />;

  const facebookGroupModal = () =>
    facebookGroupModalOpen && showModals && <FacebookGroupWarning onModalClose={closeFacebookGoupModal} />;

  const renderConnectToFacebookModal = () =>
    connectFBModalOpened &&
    showModals && (
      <ConnectToFacebookModal
        waveApiUrl={otherProps.waveApiUrl}
        destinationTitle={destinationTitle}
        isReconnect={isReconnect}
        onModalClose={closeConnectFBModal}
      />
    );

  return [
    addDestinationList,
    renderConnectToFacebookModal,
    facebookGroupModal,
    renderRTMPModal,
    renderAmazonLiveModal
  ] as const;
};

export default useAddDestination;
